// extracted by mini-css-extract-plugin
module.exports = {"grid":"artist-grid-module--grid--2ESvx"};